export enum TaskParty {
    Neutral = "Neutral",
    Office = "Office",
    Customer = "Customer"
}
